import { createFileRoute, notFound } from "@tanstack/react-router";

import { LegalPage, isPublicLocale, legalHead } from "@/components/legal-page";

export const Route = createFileRoute("/$lang/terms")({
  beforeLoad: ({ params }) => {
    if (!isPublicLocale(params.lang)) throw notFound();
  },
  head: ({ params }) => legalHead("terms", params.lang),
  component: RouteComponent,
});

function RouteComponent() {
  const { lang } = Route.useParams();
  return <LegalPage slug="terms" lang={lang} />;
}
